// ?= is look ahead. We are matching for
// 1. At least one upper case character
// 2. At least one lower case character
// 3. At least one digit
// 4. At least 12 characters long
export const PASSWORD_REGEX =
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d@$!%*#?&()]{12,}$/;

export const PASSWORD_REGEX_ANTI = /[^A-Za-z\d@$!%*#?&()]+?/g;

export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const BOTS_REGEX = /bot|crawl|spider/i;

export const PHONE_NUMBER_REGEX = /\d{10,11}/;
